"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ScrollTo = /** @class */ (function (_super) {
    __extends(ScrollTo, _super);
    function ScrollTo(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultScrollDuration = 300;
        _this.scroll = function () {
            var $ref = $(_this.ref.current);
            var $scrollParent = $ref.scrollParent();
            requestAnimationFrame(function () {
                if (!$ref.isVisibleInParent($scrollParent)) {
                    Pb.scrollTo($ref, _this.getScrollDuration(), {
                        onAfter: _this.props.doneScrolling
                    });
                }
                else
                    _this.props.doneScrolling();
            });
        };
        _this.ref = React.createRef();
        return _this;
    }
    ScrollTo.prototype.componentDidMount = function () {
        if (this.props.shouldScroll)
            this.scroll();
    };
    ScrollTo.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.shouldScroll && !prevProps.shouldScroll)
            this.scroll();
    };
    ScrollTo.prototype.render = function () {
        return React.createElement("span", { ref: this.ref });
    };
    ScrollTo.prototype.getScrollDuration = function () {
        return this.props.scrollDuration !== undefined ? this.props.scrollDuration : this.defaultScrollDuration;
    };
    return ScrollTo;
}(React.Component));
exports.ScrollTo = ScrollTo;
function ScrollToOnRender() {
    var _a = React.useState(true), shouldScroll = _a[0], setShouldScroll = _a[1];
    return React.createElement(ScrollTo, { shouldScroll: shouldScroll, doneScrolling: function () { return setShouldScroll(false); } });
}
exports.ScrollToOnRender = ScrollToOnRender;
